import { IAzureWebApp } from './../interfaces/azure/webapp.interface';
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    standalone: false,
    name: "filterWebapps"
})
export default class SearchFilterWebappsPipe implements PipeTransform {
    transform(webapps: IAzureWebApp[], searchTerm: string): IAzureWebApp[] {   
        if(!searchTerm)
            return webapps   
        return webapps.filter((webApp: IAzureWebApp) => { 
            const fieldsToSearch: string[] = [webApp.pullRequestTitle || "", webApp.name!]
            return fieldsToSearch
                .filter((field) => {
                    return field.toLowerCase().includes(searchTerm.toLowerCase())                
                }).length
        })
    }
}